<div
  *ngIf="(locales$ | async)?.length > 1"
  class="flex justify-between py-3 px-5"
>
  <div></div>
  <app-select-language-block></app-select-language-block>
</div>
